<div style="margin-top: 6%;">
    <div class="msgContainer">
        <img class="warning" src="../../../../assets/images/error-svgrepo-com.png" alt="" /> 
        <div>{{message}}</div>
    </div>
</div>